import config from 'constants/config'
import {
  AZUPAY_PAY_ID_PAYMENT_TYPE,
} from 'constants/payment'
import getPaymentMethods from 'lib/payment/getPaymentMethods'

export const isPaymentTypeAzupayPayIdEnabled = (currencyCode: string): boolean => {
  return !!currencyCode && !!config.PAYMENT_TYPE_AZUPAY_PAY_ID_ENABLED && getPaymentMethods(currencyCode).includes(AZUPAY_PAY_ID_PAYMENT_TYPE)
}
